import { useContext } from 'react';
import { FormControl, InputBase, MenuItem, Select, styled } from '@mui/material';
import { ChevronDownIcon, LocationIcon } from 'app/agriculture/icons';
import './agriculture_farm_selector.scss';
import { FarmContext } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/FarmContextProvider';

const ThemedInput = styled(InputBase)(() => ({
    '& .MuiInputBase-input': {
        backgroundColor: 'white',
        border: '1px solid #eee',
        borderRadius: 8,
        padding: 12,
        height: 'auto',
        lineHeight: '1em',
        maxWidth: 160,
        '&:focus': {
            borderRadius: 8,
        },
    },
}));

export function AgricultureFarmSelector({
    defaultValue,
    onChange,
}: {
    defaultValue: number;
    onChange: (farmId: number) => void;
}) {
    const { farms } = useContext(FarmContext);

    return (
        <FormControl className="Ag_FarmSelector" hiddenLabel>
            <Select
                className="Ag_FarmSelector__select"
                defaultValue={defaultValue}
                onChange={({ target: { value } }) => {
                    onChange(Number(value));
                }}
                input={<ThemedInput />}
                renderValue={(value) => {
                    const farm = farms.find(({ id }) => id === value);
                    if (farm == null) throw new Error(`cant find farm: ${value}`);

                    return (
                        <div className="Ag_FarmSelector__value">
                            <LocationIcon className="Ag_FarmSelector__value__icon" />
                            <label className="Ag_FarmSelector__value__text">{farm.name}</label>
                        </div>
                    );
                }}
                IconComponent={ChevronDownIcon}
            >
                {farms.map(({ id, name }) => (
                    <MenuItem key={id} value={id}>
                        {name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
